import type { AvailableFeatureIntros } from '@smart-tv/typings/content';
import { FeatureIntroLocation } from '@smart-tv/typings/content';

import boyTablet from '../../scaffold/images/boy-tablet.png';
import ladyWithRemote from '../../scaffold/images/lady-with-remote.png';
import sleepingGirl from '../../scaffold/images/SleepingGirl.png';

// Set to true to use the mock instead of getActiveFeatureIntros (development builds only)
export const USE_FEATURE_INTRO_MOCK = true;

export const mockFeatureIntros: AvailableFeatureIntros = [
  {
    id: 'mock-intro-multi-step-02',
    name: 'Mock: multi-step frontpage intro',
    locationToShowIntro: 'FRONTPAGE' as FeatureIntroLocation,
    style: 'default',
    steps: [
      {
        id: 'mock-intro-multi-step-1',
        subHeadline: 'Nyhed',
        headline: 'Velkommen til den nye forside',
        description:
          'Vi har gjort det nemmere at finde dine favoritter. Gennemse dine kanaler og programmer direkte fra forsiden.',
        media: { mediaType: 'image', mediaUrl: ladyWithRemote }
      },
      {
        id: 'mock-intro-multi-step-2',
        subHeadline: 'Favoritter',
        headline: 'Gem dine favoritter',
        description:
          'Tilføj programmer og kanaler til dine favoritlister, så du altid har dem lige ved hånden.',
        media: { mediaType: 'image', mediaUrl: boyTablet }
      },
      {
        id: 'mock-intro-multi-step-3',
        headline: 'Uden subheadline',
        description:
          'Dette trin har ingen subheadline og en længere beskrivelse for at teste, hvordan teksten ombrydes på mindre skærme, når der er mere indhold end normalt i dialogen.',
        media: { mediaType: 'image', mediaUrl: sleepingGirl }
      }
    ]
  },
  {
    id: 'mock-intro-single-step-02',
    name: 'Mock: single-step frontpage intro',
    locationToShowIntro: 'FRONTPAGE' as FeatureIntroLocation,
    style: 'default',
    steps: [
      {
        id: 'mock-intro-single-step-1',
        subHeadline: 'Tip',
        headline: 'Kun ét trin',
        description:
          'Denne intro har kun ét trin, så der vises ingen trinindikator og kun Luk-knappen.',
        media: { mediaType: 'image', mediaUrl: boyTablet }
      }
    ]
  },
  {
    id: 'mock-intro-player',
    name: 'Mock: player intro (should not show on frontpage)',
    locationToShowIntro: 'PLAYER' as FeatureIntroLocation,
    style: 'default',
    steps: [
      {
        id: 'mock-intro-player-1',
        headline: 'Player intro',
        description: 'Denne intro må ikke vises på forsiden.'
      }
    ]
  },
  {
    id: 'mock-intro-player-2',
    name: 'Mock: player intro (should not show on frontpage)',
    locationToShowIntro: 'PLAYER' as FeatureIntroLocation,
    style: 'default',
    steps: [
      {
        id: 'mock-intro-player-fisk',
        headline: 'Player intro',
        description: 'denne er også en generel player feature intro.'
      }
    ]
  },
  {
    id: 'mock-intro-live-player-1',
    name: 'Mock: player intro (should not show on frontpage)',
    locationToShowIntro: FeatureIntroLocation.LIVE_PLAYER,
    style: 'default',
    steps: [
      {
        id: 'fisk-2',
        headline: 'live Player intro',
        description: 'du ser live-indhold i playeren.'
      }
    ]
  },
  {
    id: 'mock-intro-sff-player-1',
    name: 'Mock: SFF player intro (should not show on frontpage)',
    locationToShowIntro: FeatureIntroLocation.SFF_PLAYER,
    style: 'default',
    steps: [
      {
        id: 'fisk',
        headline: 'SFF Player intro',
        description: 'du ser SFF-indhold i playeren.'
      }
    ]
  },
  {
    id: 'mock-intro-vod-player-1',
    name: 'Mock: VOD player intro (should not show on frontpage)',
    locationToShowIntro: FeatureIntroLocation.VOD_PLAYER,
    style: 'default',
    steps: [
      {
        id: 'mock-intro-vod-player-1',
        headline: 'VOD Player intro',
        description: 'du ser VOD-indhold i playeren.'
      }
    ]
  }
];
